'use strict';

var QueryString = {};

// Deprecate and replace with https://developer.mozilla.org/en-US/docs/Web/API/URLSearchParams
QueryString.parse = function (qs) {
  var sep = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '&';
  var eq = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '=';

  var obj = {};

  if (typeof qs !== 'string' || qs.length === 0) {
    return obj;
  }

  return qs.split(sep).reduce(function (prev, kvp) {
    var x = kvp.split(eq).map(function (part) {
      return part.replace(/\+/g, ' ');
    });
    var key = decodeURIComponent(x[0], true);
    var value = decodeURIComponent(x.slice(1).join(eq), true);

    if (!(key in prev)) {
      prev[key] = value;
    } else if (Array.isArray(prev[key])) {
      prev[key].push(value);
    } else {
      prev[key] = [prev[key], value];
    }

    return prev;
  }, obj);
};

module.exports = QueryString;
